import React from 'react'
import { Button, Input, Tooltip, message } from 'antd'
import { HistoryOutlined } from '@ant-design/icons'
import { productApi } from 'api/product'
import { IFrontVariationProduct } from 'models/product'
import { showServerError } from 'shared/utils/showServerError'
import styles from '../ProductForm.module.scss'

const PRICE_PATTERN = /^[\d\s,.]*$/

const parsePrice = (value: string) =>
  Number(value.replace(/\s/g, '').replace(',', '.'))

interface IVariationPriceProps {
  product?: IFrontVariationProduct
  // цена основного товара правится полем «Стоимость» самой формы
  readOnly?: boolean
  onChange?: (product: IFrontVariationProduct) => void
  onOpenHistory: (productId: string) => void
}

export const VariationPrice: React.FC<IVariationPriceProps> = ({
  product,
  readOnly,
  onChange,
  onOpenHistory
}) => {
  const [draft, setDraft] = React.useState<string | null>(null)
  const [isSaving, setIsSaving] = React.useState(false)

  const savedValue =
    product?.price != null ? Number(product.price).toLocaleString('ru-RU') : ''

  // Вариация — отдельный товар: цена сохраняется сразу, не дожидаясь сохранения формы
  const save = async () => {
    if (draft === null || !product) return
    const nextPrice = parsePrice(draft)
    if (!draft.trim() || Number.isNaN(nextPrice) || nextPrice <= 0) {
      setDraft(null)
      message.error('Укажите корректную цену')
      return
    }
    if (nextPrice === Number(product.price)) {
      setDraft(null)
      return
    }
    try {
      setIsSaving(true)
      await productApi.quickUpdateProduct(product.id, { price: nextPrice })
      onChange?.({ ...product, price: nextPrice })
      message.success('Цена вариации обновлена')
    } catch (error) {
      showServerError(error)
    } finally {
      setIsSaving(false)
      setDraft(null)
    }
  }

  return (
    <div className={styles.variationPrice}>
      <Input
        size='middle'
        placeholder='—'
        suffix='₽'
        value={draft ?? savedValue}
        disabled={readOnly || !product || isSaving}
        onChange={(event) =>
          PRICE_PATTERN.test(event.target.value) && setDraft(event.target.value)
        }
        onBlur={save}
        onPressEnter={(event) => event.currentTarget.blur()}
      />
      <Tooltip title='История изменений стоимости'>
        <Button
          type='text'
          size='small'
          htmlType='button'
          icon={<HistoryOutlined />}
          aria-label='История изменений стоимости'
          disabled={!product}
          onClick={() => product && onOpenHistory(product.id)}
        />
      </Tooltip>
    </div>
  )
}
